import { ManageHostManagementContainer } from '@/features/store-management/premium-stores/form/ManageHostManagementContainer';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/host-management/$clubid/$manage-host/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ManageHostManagementContainer />;
}
